/**
 * Typed lines as a list of distinct entries: trimmed, inner spaces collapsed,
 * blanks dropped, and repeats (ignoring case) kept once.
 *
 * A typed option or criterion is identified by its text — the quick apps use it
 * as the id — so two identical lines are one entry. Kept apart they share that
 * id: three options all typed "test" took every dot together on the live board.
 * Every write of `isolated_items` goes through this: createSession and
 * setIsolatedItems both (roadmap N-6 reproduced the second, the session page's
 * Items tab, after the first was closed).
 */
export function uniqueLines(lines: readonly string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const line of lines) {
    const text = line.replace(/\s+/g, ' ').trim();
    if (!text) continue;
    const key = text.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(text);
  }
  return out;
}
